/**
 * @author: Wangwei
 * @description: 打卡营详情页
 */
import { useRequest, useParams, Helmet, history } from 'umi';
import styles from './css/cmapDetailsCSS.less';
import { useState, useEffect } from 'react';
import cx from 'classnames';
import { Tabs, message } from 'antd';
import DynamicTabs from './components/dynamic/dynamicTabs';
import Banner from './components/Banner';
import StudyMain from './components/StudyMain';
import EntryFormModal from '@/pages/EntryFormModal';
import { studentBaseInfo } from '@/utils/requests/camp/requests_study';
import { Batch, StudyInfoType } from '@/types/camp/study/studentBaseInfoType';
import NeedLogin from '@/components/isLogin';
import StudyReport from '@/pages/camp/components/detail/studyReport';
import { getCardCampBatch } from '@/services/CardCampRequest';
import EventTracking from '@/pages/camp/components/tracking/EventTracking';
import { getParame } from '@/pages/camp/util/indexUtil';
import { CampStudyState } from '@/types/camp/study';
import { useLocalStorageState } from 'ahooks';

export default function CampDetails() {
  const [newTitle, setNewTitle] = useState<string>();
  const { id: batchId } = useParams() as { id: string };
  const [studentInfo, setStudentInfo] = useState<StudyInfoType>();
  const [tabKey, setTabKey] = useState('1');
  const [open, setOpen] = useState<boolean>(false);
  const [entryOpen, setEntryOpen] = useState<boolean>(false);
  const [signUpAgain, setSignUpAgain] = useState<boolean>(false);
  const [entryBatch, setEntryBatch] = useState<Batch>();
  const [openStudyReport, setOpenStudyReport] = useLocalStorageState<string[]>('study_report');

  // 获取学习节点基础信息
  const { run: studentBaseInfoRequest } = useRequest(
    () => {
      return studentBaseInfo(batchId);
    },
    {
      manual: true,
      onSuccess: (res: any) => {
        if (res.signUp === false) {
          message.warning('请先报名打卡营');
          setTimeout(function () {
            history.push(`/v2/camp/${res.cardCampId}`);
          }, 1000);
        } else {
          setStudentInfo(res);
        }
      },
    },
  );

  const { run: getCardCampBatchRun } = useRequest(
    (batchId: string) => {
      return getCardCampBatch(batchId);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setEntryBatch(res);
      },
    },
  );

  useEffect(() => {
    if (studentInfo) {
      if (signUpAgain) {
        getCardCampBatchRun(studentInfo.nextBatchId);
      } else {
        setEntryBatch(studentInfo.batch);
      }
    }
  }, [signUpAgain, studentInfo]);

  useEffect(() => {
    studentBaseInfoRequest();
  }, [batchId]);

  useEffect(() => {
    setNewTitle(studentInfo?.camp.name);
  }, [studentInfo?.camp.name]);

  // 首次学习报告弹出功能
  useEffect(() => {
    if (studentInfo?.campStudyState === CampStudyState.CAMP_SUCCESS && studentInfo?.certificate) {
      if (studentInfo?.batchId && !openStudyReport?.includes(studentInfo.batchId)) {
        setOpen(true);
        setOpenStudyReport((prev) => [...(prev || []), studentInfo.batchId]);
      }
    }
  }, [studentInfo?.batchId]);

  // tab路由 & title
  const tabParame = getParame('tab');
  const tabEnArr = [['study'], ['comminicate']];
  const tabCnArr = [['打卡学习'], ['交流分享']];

  const getQuery = () => {
    switch (tabParame) {
      case 'study':
        setTabKey('1');
        break;
      case 'comminicate':
        setTabKey('2');
        break;
        break;
      default:
        setTabKey('1');
        break;
    }
  };
  useEffect(() => {
    getQuery();
  }, []);
  const handleTabChange = (key: any) => {
    setTabKey(key);
    window.history.pushState({}, '', '?tab=' + tabEnArr[key - 1]);
  };

  return (
    <>
      <NeedLogin />
      {newTitle && (
        <Helmet>
          <title>{`${newTitle}- 打卡营 - 帆软学院`}</title>
        </Helmet>
      )}

      {studentInfo && (
        <>
          <Banner
            studentBaseInfo={studentInfo}
            setOpen={setOpen}
            setEntryOpen={setEntryOpen}
            setSignUpAgain={setSignUpAgain}
          />

          <div className={cx(styles.camp_details_index_box, 'w1200')}>
            {studentInfo && studentInfo.campStudyState > 0 ? (
              <Tabs
                size="large"
                defaultActiveKey="1"
                activeKey={tabKey}
                indicator={{ size: (origin) => origin - 26 }}
                onChange={handleTabChange}
                items={[
                  {
                    label: '打卡学习',
                    key: '1',
                    children: <StudyMain studentBaseInfo={studentInfo} setTabKey={setTabKey} />,
                  },
                  {
                    label: '交流分享',
                    key: '2',
                    children: <DynamicTabs campId={studentInfo?.camp.id} />,
                  },
                ]}
              />
            ) : (
              <div style={{ marginTop: 24 }}>
                <StudyMain studentBaseInfo={studentInfo} setTabKey={setTabKey} />
              </div>
            )}
          </div>

          <div>
            <StudyReport studentInfo={studentInfo} open={open} setOpen={setOpen} />
          </div>
          {entryBatch && (
            <EntryFormModal
              entryValue={studentInfo?.entryValue}
              batch={entryBatch}
              campName={studentInfo?.camp.name}
              open={entryOpen}
              setOpen={setEntryOpen}
            />
          )}
          <EventTracking />
        </>
      )}
    </>
  );
}
